import { Radar } from 'vue-chartjs'

export default {
  name: 'radar-chart',
  mixins: [Radar]
}
